import type { FaireThemeEntity } from "../../entity_types/theme";

export const the_waterproof_gold_standard: FaireThemeEntity = {
  token: "the-waterproof-gold-standard",
  type: "theme",
  name: "The Waterproof Gold Standard",
  description: "High-shine, low-maintenance 18k gold-plated stainless steel jewelry -- waterproof and tarnish-resistant.",
  teaser: "Tarnish-proof gold jewelry that matches your brand promise of durable elegance.",
  detail: "K&K Visage focuses on long-lasting beauty. Quality-conscious jewelry that doesn't tarnish fits your brand promise. Built around 18k Gold Filled Thick Small Hoop Earrings and Evereign 18K Gold Non-Tarnish Knot Necklace.",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_x8zn8z9mdw",
    "p_5lazl70x",
    "p_ps3ufaemx5",
    "p_9ebda6svmo",
    "p_xpyyzvehfy",
    "p_6rm9cthdfr",
    "p_juex45tn7n",
    "p_vwssret42y",
    "p_egnnzqszi6",
    "p_kk9u5fmpf9",
    "p_bryjg59c5k",
    "p_mxau2n7tg4",
    "p_u3fcq7r777",
    "p_74jb4dfpzt",
    "p_ze2mdxspej",
    "p_kjwfdfzbjt",
    "p_abkkzv5z3b",
    "p_ju2puhctrf",
    "p_vkva66tczr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
